export * from '../../original/js/components/pagination';

// soon to be depricated.
import { Pagination } from '../../original/js/components/pagination';

export default Pagination
